<template>
  <header class="edit-ticket-header">
    <section v-if="isLoadingTicket" class="edit-ticket-header__buttons">
      <ButtonText
        class="edit-ticket-header__buttons__button"
        :iconLeft="iconXSmall"
        size="extra-small"
        @onClicked="closeModal"
      ></ButtonText>
    </section>
    <p v-if="!isLoadingTicket" class="edit-ticket-header__title">
      {{ selectedTicket?.title ?? '' }}
    </p>
    <section v-if="!isLoadingTicket" class="edit-ticket-header__buttons">
      <TooltipStandardV2
        v-if="store.getters.hasErrandAdminAccess && selectedTicket?.active"
        :text="t('general__text__delete')"
        :arrowPosition="'top-center'"
        :verticalOffset="2"
      >
        <ButtonText
          class="edit-ticket-header__buttons__button"
          :iconLeft="iconTrash2Small"
          size="extra-small"
          @onClicked="emits('deleteTicket')"
        ></ButtonText>
      </TooltipStandardV2>
      <TooltipStandardV2
        v-if="store.getters.hasErrandEditorAccess && selectedTicket?.active"
        :text="t('general__text__archive')"
        :arrowPosition="'top-center'"
        :verticalOffset="2"
      >
        <ButtonText
          class="edit-ticket-header__buttons__button"
          :iconLeft="iconArchiveSmall"
          size="extra-small"
          @onClicked="emits('archiveTicket')"
        ></ButtonText>
      </TooltipStandardV2>
      <DividerVertical v-if="selectedTicket?.active" style="margin: 0 8px" />
      <ButtonText
        class="edit-ticket-header__buttons__button"
        :iconLeft="iconXSmall"
        size="extra-small"
        @onClicked="closeModal"
      ></ButtonText>
    </section>
  </header>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useGeneralStore } from '@/pinia'
import { useStore } from 'vuex'
import { computed } from 'vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import DividerVertical from '@/design-system/atoms/DividerVertical.vue'
import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'
import iconXSmall from '@/design-system/assets/icons/Icon-X-Small.svg'
import iconTrash2Small from '@/design-system/assets/icons/Icon-Trash-2-small.svg'
import iconArchiveSmall from '@/design-system/assets/icons/Icon-Archive-Small.svg'

interface EMITS {
  (e: 'archiveTicket'): void
  (e: 'closeEditTicketModal', value: boolean): void
  (e: 'deleteTicket'): void
}
const emits = defineEmits<EMITS>()

const props = defineProps<{
  loadingTicket: boolean
}>()

const { t } = useI18n()
const piniaStore = useGeneralStore()
const store = useStore()

const isLoadingTicket = computed(() => props.loadingTicket)
const selectedTicket = computed(() => piniaStore.selectedTicket)

function closeModal() {
  piniaStore.setSelectedTicket(null)
  emits('closeEditTicketModal', false)
}
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';
@use '@/design-system/design-tokens/mixins.scss';

.edit-ticket-header {
  display: flex;
  height: 32px;
  margin-bottom: 16px;
  &__buttons {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 4px;
    margin-left: auto;
    &__button {
      height: 24px;
      min-width: 24px;
      padding: 0;
      width: 24px;
      &:nth-child(3) {
        margin-left: 8px;
      }
    }
  }
  &__title {
    color: variables.$color-greyscale-content;
    margin: 0;
    margin-right: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: max-content;
    @include font-mixins.desktop-bold-h4;
  }
}
</style>
